import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { Router } from '@angular/router';
import { BusinessUnitToName } from '@app/models/business-unit';
import { UserRolesMappings } from '@app/models/user';
import * as rolesUtils from '@app/role.utils';
import { ApiService } from '@app/services/api/api.service';
import { FlashService } from '@app/services/flash.service';
import * as FileActions from '@core/actions/file.actions';
import * as UserActions from '@core/actions/user.actions';
import * as fromBusinessUnit from '@core/reducers/business-unit.reducer';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store, select } from '@ngrx/store';

import { FollowIdComponent } from '@app/modules/supplier-portal/components/followId-confirmation/followId-confirmation.component';
import { ModalQueryFilter } from '../modal-query-filter/modal-query-filter.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent implements OnInit {
  @Input()
  me;

  @Input()
  counter = 0;

  @Input()
  busy;

  @Input()
  followYears;

  @Output()
  logout = new EventEmitter();

  @Input()
  businessUnits;

  businessUnits$ = this.store.pipe(select(fromBusinessUnit.getAll));
  businessRed;

  isNavbarCollapsed = true;
  _modalRef;
  _modalRefSupplier = null;
  _alive = true;

  get isCountryManager() {
    return this.me && this.me.role && rolesUtils.isCountryManager(this.me.role);
  }

  get isProductManager() {
    return this.me && this.me.role && rolesUtils.isProductManager(this.me.role);
  }

  get isPlanner() {
    return this.me && this.me.role && rolesUtils.isPlanner(this.me.role);
  }

  get isDesigner() {
    return this.me && this.me.role === 'designer';
  }

  get isAdmin() {
    return this.me && this.me.role === 'admin';
  }

  get isSuperAdmin() {
    return this.me && this.me.role === 'super-admin';
  }

  get isRegionalBuyer() {
    return this.me && rolesUtils.isOnlyRegionalUser(this.me.role);
  }

  get isCountryBuyer() {
    return rolesUtils.isCountryUser(this.me.role);
  }

  get isManager() {
    return this.me && this.me.role === 'manager';
  }

  get isRegionalManager() {
    return rolesUtils.isRegionalManager(this.me.role);
  }

  get isCategoryManager() {
    return rolesUtils.isCategoryManager(this.me.role);
  }

  get isSar() {
    return this.me && this.me.role === 'sar';
  }

  get isMerchant() {
    return this.me && this.me.role === 'merchant';
  }

  get isRegionalAnalyst() {
    return this.me && this.me.role === 'regional-analyst';
  }

  get isComex() {
    return this.me && this.me.role === 'comex';
  }

  get isComexCountry() {
    return this.me && this.me.role === 'comex-country';
  }

  get isManagerUdn() {
    return this.me && this.me.role === 'manager-udn';
  }

  get role() {
    return this.me && this.me.role && UserRolesMappings[this.me.role];
  }

  get userBusinesses() {
    return this.me && this.me.UserBusinesses;
  }

  get groupName() {
    // return this.me && this.me.FollowGroup && this.me.FollowGroup.name;
    return 'Gte Omnicanalidad & Planificación Reg';
  }

  get avatar() {
    if (this.me) {
      return this.me.avatarUrl
        ? this.me.avatarUrl
        : `https://ui-avatars.com/api/?name=${this.me.firstName}+${this.me.lastName}`;
    }
  }

  get businessUnitName() {
    const businessUnit = this.me && this.me.businessUnit;
    return businessUnit ? BusinessUnitToName[businessUnit] : null;
  }

  get countryId() {
    return this.me && this.me.CountryId;
  }

  get logo() {
    const now = new Date();
    let logoImg = 'assets/follow_logo.png';
    if (now.getMonth() === 9) {
      logoImg = 'assets/follow_logo_halloween.png';
    } else if (now.getMonth() === 10 || now.getMonth() === 11) {
      logoImg = 'assets/themes/follow_logo_christmas.webp';
    }
    return logoImg;
  }

  get banner() {
    const now = new Date();
    let logoImg = '';
    if (now.getMonth() === 9) {
      logoImg = 'assets/follow_banner.png';
    } else if (now.getMonth() === 10 || now.getMonth() === 11) {
      logoImg = 'assets/themes/follow_banner_christmas.webp';
    }
    return logoImg;
  }

  getBusinessUser(id) {
    this.businessUnits$.subscribe((x) => {
      this.businessRed = x.reduce((item, b) => {
        item[b.id] = b;
        return item;
      }, {});
    });

    if (this.businessRed[id]) {
      return this.businessRed[id].code;
    }
  }

  enabledBusiness(id) {
    this.businessUnits$.subscribe((x) => {
      this.businessRed = x.reduce((item, b) => {
        item[b.id] = b;
        return item;
      }, {});
    });

    if (
      this.businessRed[id] &&
      this.businessRed[id].code === this.me.businessUnit
    ) {
      return true;
    }
  }
  constructor(
    private store: Store<any>,
    private apiService: ApiService,
    private modal: NgbModal,
    private flash: FlashService,
    private router: Router
  ) {}

  ngOnInit() {}

  updateBusiness(UserId, BusinessId) {
    const data = {
      UserId: UserId,
      BusinessId: BusinessId,
    };
    this.store.dispatch(new UserActions.UpdateBusiness(UserId, data));
  }

  masterKeyReport() {
    const nameFile = 'Reporte LLave Maestra';
    this.store.dispatch(new FileActions.ExportMasterKey(nameFile));
  }

  totalSupplier(part) {
    this.store.dispatch(new FileActions.ExportTotalSupplier(part));
  }

  upsertFollowImg() {
    this.apiService.upsertFollowImg().subscribe((i) => {
      console.log('i => ', i);
    });
  }

  downloadQuery(typeDownload) {
    if (typeDownload === 'follow_total') {
      this._modalRef = this.modal.open(ModalQueryFilter, {
        backdrop: 'static',
        keyboard: false,
      });
      this._modalRef.componentInstance.followYears = this.followYears;
      this._modalRef.result.then(
        (result) => {
          // do nothing
        },
        (res) => {
          if (res) {
            if (res.yearsSelected.length > 0 || res.n5Selected.length > 0) {
              this.store.dispatch(
                new FileActions.DownloadQuery(typeDownload, res)
              );
            } else {
              this.flash.emit({
                type: 'danger',
                message: 'Seleccione algún filtro',
              });
            }
          }
        }
      );
    } else {
      this.store.dispatch(new FileActions.DownloadQuery(typeDownload));
    }
  }

  supplierPortalRouter() {
    if (this.isMerchant || this.isProductManager) {
      this._modalRefSupplier = this.modal.open(FollowIdComponent, {
        backdrop: 'static',
        keyboard: false,
      });
      this._modalRefSupplier.result.then(
        (result) => {
          // do nothing
        },
        (res) => {
          if (res !== null) {
            this.router.navigate(['/supplier-portal/', res]);
          }
        }
      );
      this._modalRefSupplier = null;
    } else {
      this.router.navigate(['/supplier-portal']);
    }
  }
}
